import { COLORS, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledProductsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
`;

export const StyledLogsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledLogFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StyledLogDate = styled.div`
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
  color: ${COLORS.GRAY_PRIMARY};
`;
